import storage from 'store2'
import request from '@/utils/request'
import qs from 'qs';
import { Message, Loading } from 'element-ui'

/**
 * 路由定义（主进程与渲染进程通信频道定义）
 */
const ipcApiRoute = {
  test: 'controller.example.test',
  messageShow: 'controller.example.messageShow',
  messageShowConfirm: 'controller.example.messageShowConfirm',
  selectFolder: 'controller.example.selectFolder',
  openDirectory: 'controller.example.openDirectory',
  loadViewContent: 'controller.example.loadViewContent',
  removeViewContent: 'controller.example.removeViewContent',
  createWindow: 'controller.example.createWindow',
  sendNotification: 'controller.example.sendNotification',
  initPowerMonitor: 'controller.example.initPowerMonitor',
  getScreen: 'controller.example.getScreen',
  openSoftware: 'controller.example.openSoftware', 
  autoLaunch: 'controller.example.autoLaunch',
  setTheme: 'controller.example.setTheme',
  getTheme: 'controller.example.getTheme',
  checkForUpdater: 'controller.example.checkForUpdater',
  downloadApp: 'controller.example.downloadApp',
  dbOperation: 'controller.example.dbOperation',
  sqlitedbOperation: 'controller.example.sqlitedbOperation',
  uploadFile: 'controller.example.uploadFile',
  checkHttpServer: 'controller.example.checkHttpServer',
  doHttpRequest: 'controller.example.doHttpRequest',
  doSocketRequest: 'controller.example.doSocketRequest',
  ipcInvokeMsg: 'controller.example.ipcInvokeMsg',
  ipcSendSyncMsg: 'controller.example.ipcSendSyncMsg',
  ipcSendMsg: 'controller.example.ipcSendMsg',
  getWCid: 'controller.example.getWCid',
  startJavaServer: 'controller.example.startJavaServer',
  closeJavaServer: 'controller.example.closeJavaServer',
  someJob: 'controller.example.someJob',
  timerJobProgress: 'controller.example.timerJobProgress',
  hello: 'controller.example.hello',
  action:'controller.example.actionMian',
  editWinSize:'controller.example.editWinSize',
  newWinSize:'controller.example.newWinSize',
  saveFile:'controller.example.saveFile',
  openFile:'controller.example.openFile',
  closeWinByName:'controller.example.closeWinByName',
  clearCache:'controller.example.clearCache'
}

/**
 * 特殊的路由（频道）定义
 */
const specialIpcRoute = {
  appUpdater: 'app.updater', // 此频道在后端也有相同定义
  window1ToWindow2: 'window1-to-window2', // 窗口之间通信
  window2ToWindow1: 'window2-to-window1', // 窗口之间通信
}

/**
 * 访问内置http服务
 */
const requestHttp = (uri, parameter) => {
  // url转换
  const config = storage.get('httpServiceConfig');
  const host = config.server || 'http://localhost:7071';
  let url = uri.split('.').join('/');
  url = host + '/' + url;
  console.log('url:', url);
  return request({
    url: url,
    method: 'post', 
    data: parameter, // body
    params: {}, // URL 参数
    timeout: 60000,
  })
}

/**
 * 访问外部http服务POST
 */
const requestHttpPost = (url, parameter) => {
  // url转换
  return request({
    url: url,
    method: 'post', 
    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    data: qs.stringify(parameter), // body
    params: {}, // URL 参数
    timeout: 60000,
  })
}

/**
 * 访问外部http服务POST
 */
const requestHttpPostByOnline = (url, parameter) => {
  // url转换
  return request({
    url: url,
    method: 'post',
    header: {
      Accept: 'text/json',
      'Content-Type': 'application/json;charset=UTF-8',
      platform: "PC",
    },
    data: parameter, // body
    params: {}, // URL 参数
    timeout: 60000,
  })
}
/**
 * 访问外部http服务GET
 */
const requestHttpGet = (url, parameter) => {
  // url转换
  return request({
    url: url,
    method: 'get', 
    data: {}, // body
    params: parameter, // URL 参数
    timeout: 60000,
  })
}

const requestHttpUpload = (url, parameter) => {
  // url转换
  let fromData = new FormData()
  fromData.append('file',parameter.file)
  // fromData.append('path',parameter.path)
  //大文件上传提示：全程 Loading + 实时百分比，失败有反馈
  const loading = Loading.service({ fullscreen: true, lock: true, text: '文件上传中 0%' })
  return request({
    url: url,
    method: 'post',
    headers: {
      Accept: '*/*',
      'Content-Type': 'multipart/form-data',
      platform: "PC"
    },
    data: fromData, // body
    //大文件(50MB+)按实测网速需 2 分钟以上，原 60 秒必超时，单独放宽到 10 分钟
    timeout: 600000,
    //上传进度：实时刷新 Loading 百分比
    onUploadProgress: (e) => {
      if (e && e.lengthComputable && e.total) {
        loading.setText('文件上传中 ' + Math.round(e.loaded * 100 / e.total) + '%')
      }
    },
  }).then(res => {
    loading.close()
    return res
  }).catch(err => {
    loading.close()
    Message.error('文件上传失败，请重试（文件过大或网络中断）')
    return null
  })
}

export {
  ipcApiRoute,
  specialIpcRoute,
  requestHttp,
  requestHttpPost,
  requestHttpUpload,
  requestHttpPostByOnline,
  requestHttpGet
}
